module.exports = __webpack_public_path__ + "static/media/everyone-is-ahead-now.102202f3.txt";